<script>
    import bgIndexImage from '../../assets/img/bg_index.png';
    import redIndexImage from '../../assets/img/red_index.png';
    import guohuiImage from '../../assets/img/header_gh.png';
    import guohuiImageNew from '../../assets/img/header_gh_new.png';
    import rightArrowImage from '../../assets/img/right_arrow.png';
    import huishengImage from '../../assets/img/ducha_huisheng.png';
    import { NormalButton } from 'southcn-mobile-ui';
    import WidgetFooter from '../widgets/WidgetFooer';
    import PostItem from '../widgets/PostItem';
    import TopicItem from '../widgets/TopicItem';
    import Tab from '../widgets/Tab';
    import ExposureItem from '../widgets/ExposureItem';
    export default {
        name: 'pageIndex',
        prop: {},
        data () {
            return {
                redIndexImage,
                bgIndexImage,
                guohuiImage,
                guohuiImageNew,
                rightArrowImage,
                huishengImage,
                category: {},
                postDchsList: [],
                postTopicList: [],
                postExposureList: [],
                data: {},
                token: ''
            };
        },
        methods: {
            getFullRedirectUrl (url) {
                let {protocol, host} = window.location;
                if (host.includes('localhost')) {
                    host = 'clouddev-ducha.southcn.com';
                }
                return `${protocol}//${host}${url}`;
            },
            getQueryVariable (variable) {
                let query = window.location.search.substring(1);
                let vars = query.split('&');
                for (let i = 0; i < vars.length; i++) {
                    let pair = vars[i].split('=');
                    if (pair[0] === variable) {return pair[1];}
                }
                return (false);
            },
            fetchStatisticsUrl() {
                let url = '/stat';
                this.$api(url, {}, {
                    method: 'get'
                });
            },
            fetchSxUrl () {
                let url = `/mletter?via=${this.getQueryVariable('via') || 'web'}`;
                if (window._IS_LOGIN) {
                    this.data.url = url;
                    return;
                }
                this.$api(this.$config.apiUrl.sxGenRedirectUrl, {
                    redirect_uri: this.getFullRedirectUrl(url),
                }).then(v => {
                    console.log(v);
                    this.data = v;
                }).catch(e => {
                    this.$modal.alert({
                        title: '出错',
                        text: e.errmessage
                    });
                });
            },
            handleToSx () {
                if (this.isYst && !this.token) {
                    this.handleReadyYst('click');
                    return;
                }
                const {url} = this.data;
                if (!url) {
                    this.$modal.alert({
                        text: '数据加载中，请稍后...'
                    });
                } else {
                    window.location.href = this.isYst ? `${url}&token=${this.token}` : url;
                }
            },
            init () {
                if (this.isYst) {
                    this.fetchYstUrl();
                } else {
                    this.fetchSxUrl();
                }
                this.fetchStatisticsUrl();
                this.fetchPostExposureList();
                this.fetchPostDchsList();
                this.fetchPostTopicList();
            },
            fetchYstUrl () {
                let url = `/mletter?via=${this.getQueryVariable('via') || 'web'}`;
                if (window._IS_LOGIN) {
                    this.data.url = url;
                    return;
                }
                this.$api(this.$config.apiUrl.ystGenRedirectUrl, {
                    redirect_uri: this.getFullRedirectUrl(url),
                }).then(v => {
                    console.log(v);
                    this.data = v;
                }).catch(e => {
                    this.$modal.alert({
                        title: '出错',
                        text: e.errmessage
                    });
                });
            },
            handleReadyYst (state) {
                this.$loading.show();
                window.JSBridge.ready(() => {
                    this.fetchYSTToken(state);
                });
            },
            fetchYSTToken (state) {
                const domain = window.location.href.includes('test') ? 'http://bs-test.digitalgd.com.cn' : 'https://api-yst.gdzwfw.gov.cn';
                window.JSBridge.request({
                    url: `${domain}/ebus/yqt_back/api/r/sso/GetToken`,
                    method: 'POST',
                    data: {
                        proxy_id: '004'
                    },
                    header: {
                        'Content-Type': 'application/json' // 􏱵􏱶􏱷
                    },
                    success: (data) => {
                        let result = data.data;
                        try {
                            if (typeof result === 'string') {
                                result = JSON.parse(data.data);
                            }
                        } catch (e) {
                            console.log(e);
                        }
                        if (result && result.data && result.data.token) {
                            this.token = result.data.token;
                            state === 'click' && this.handleToSx();
                        } else if (result.errcode) {
                            this.$modal.confirm({
                                title: '提示',
                                text: `当前还未登录，请点击确定按钮前往登录`,
                                okCallback: () => {
                                    const domain = window.location.href.includes('test') ? 'http://yqt-dev.digitalgd.com.cn/default/' : 'https://static-yst.gdzwfw.gov.cn/default/';
                                    window.JSBridge.openWindow({
                                        url: `${domain}#/pages/login/index`
                                    });
                                }
                            });
                        } else {
                            this.$modal.alert({
                                title: '出错',
                                text: `获取token失败：${JSON.stringify(data)}`
                            });
                        }
                        this.$loading.hide();
                    },
                    fail: (error) => {
                        this.$loading.hide();
                        this.$modal.alert({
                            title: '出错',
                            // text: `获取token失败：${error.errmsg || error.toString()}`
                            text: `获取token失败：${JSON.stringify(error)}`
                        });
                    }
                });
            },
            handlePlayVideo () {
                this.$modal.playVideo();
            },
            // 曝光台
            fetchPostExposureList(){
                this.$api(this.$config.apiUrl.postExposureList, {}, {
                    method: 'get'
                }).then(v => {
                    // v.articles = []; // 模拟曝光台没有数据
                    this.postExposureList = v.articles.splice(0, 3).map(item => {
                        item.title = item.title.split("<br/>").join(' ');
                        let abstractArr = item.abstract.split('<br/>');
                        let abstractStr = '';
                        abstractArr.forEach((ele, index) => {
                            if (index === (abstractArr.length - 1)) {
                                abstractStr = abstractStr + '<p>' + ele + '<a href="' + item.url + '" class="with-link" style="text-underline: none;color:#df2f26;">查看全文>></a>' +'</p>'
                            } else {
                                abstractStr = abstractStr + '<p>' + ele + '</p>'
                            }
                        });
                        item.abstract = abstractStr;
                        item.title = this.$util.useDivFixText(item.title);
                        return item;
                    });
                    // this.exposure = v.category;
                }).catch(e => {
                    console.log(e);
                });
            },
            fetchPostDchsList () {
                this.$api(this.$config.apiUrl.postDchsList, {}, {
                    method: 'get'
                }).then(v => {
                    this.postDchsList = v.articles.splice(0, 2).map(item => {
                        item.title = item.title.split("<br/>").join(' ');
                        item.title = this.$util.useDivFixText(item.title);

                        // 为了兼容post-item__abstract富文本显示
                        item.abstract = item.abstract + `<a href="${item.url}" style='color: #df2f26;' class="with-link">查看全文>></a>`

                        return item;
                    });
                    this.category = v.category;
                }).catch(e => {
                    console.log(e);
                });
            },
            fetchPostTopicList () {
                this.$api(this.$config.apiUrl.postTopicList, {}, {
                    method: 'get'
                }).then(v => {
                    v.articles && v.articles.forEach(item => {
                        item.short_title = item.short_title ? item.short_title.replace('<br/>', ' ').replace('<br>', ' ') : '';
                        item.short_title = item.short_title ? item.short_title.replace('<a/>', ' ').replace('<a>', ' ') : '';
                    });
                    this.postTopicList = v.articles.filter(v => v.covers && v.covers.length).splice(0, 5);

                    setTimeout(() => {
                        new window.Swiper('.topic-swiper', {
                            loop: true,
                            autoplay: 5000
                        });
                    });
                }).catch(e => {
                    console.log(e);
                });
            }
        },
        components: {NormalButton, WidgetFooter, PostItem, TopicItem, Tab, ExposureItem},
        computed: {
            categoryUrl () {
                return `/${this.category.pub_point}/`;
            },
            // exposureUrl () {
            //     return `/${this.exposure.pub_point}/`;
            // },
            isYst () {
                // return window.navigator.userAgent.match(/YST\/(\d\.\d\.\d)/);
                return false;
            }
        },
        mounted () {
            this.init();
        }
    };
</script>

<template>
    <div class="page-index">
        <img class="page-bg" :src="bgIndexImage">
        <!-- <img class="page-header-image" :src="guohuiImage"> -->
        <div class="page-header-top">
            <img :src="guohuiImageNew">
            <a id="wza" class="wza right">无障碍浏览</a>
        </div>

        <div class="page-index__content">
            <div :class="{noExposure: !postExposureList.length}">
                <tab @handleToSx='handleToSx'/>
            </div>
            <div class="page-index__content-gg">
                <h1>公&nbsp;告</h1>
                <p>
                    为深入推动党中央、国务院和省委、省政府的重大决策部署以及政策措施贯彻落实，广东省人民政府办公厅即日起设立广东省政府“互联网+督查”平台，在省政府门户网站、粤省事、粤商通、南方+客户端分别设置入口，面向社会征集四个方面问题线索或意见建议：<strong>一是</strong>党中央、国务院和省委、省政府有关重大决策部署以及政策措施不落实或落实不到位的问题线索；<strong>二是</strong>省、市、县政府及其有关部门、单位不作为慢作为乱作为的问题线索；<strong>三是</strong>因政策措施不协调不配套不完善给市场主体和人民群众带来困扰的问题线索；<strong>四是</strong>改进政府工作的意见建议。
                </p>
                <p>
                    我们将对收到的问题线索和意见建议进行汇总整理，督促我省有关地市、部门处理。对企业和群众反映强烈、带有普遍性的重要问题线索，将由省政府督查室直接派员进行督查。经查证属实、较为典型的问题，将予以公开曝光、严肃处理。
                </p>
                <p style="text-align: right">省政府办公厅</p>
                <p style="text-align: right">2021年2月1日</p>

            </div>
            <normal-button @click.native="handlePlayVideo"
                           theme="primary">留言教程视频
            </normal-button>
            <normal-button @click.native="handleToSx" theme="primary">我要留言</normal-button>
        </div>
        <div class="page-index__cat " v-if="postTopicList.length" style='overflow: hidden;padding: 0.8rem 0.4rem 0rem;'>
            <!-- <div class="topic-swiper">
                <div class="swiper-list swiper-wrapper">
                    <topic-item v-for="item in postTopicList"
                                :key="item.id"
                                :data="item"/>
                </div>
            </div> -->
            <topic-item v-for="item in postTopicList"
                        :key="item.id"
                        :data="item"/>
        </div>
        <div class="page-index__cat" id='exposure' v-if="postExposureList.length">
            <div class="page-index__cat-title">
                <img class="with-left" :src="huishengImage">
                <div>曝光台</div>
                <img class="with-right" :src="huishengImage">
            </div>
            <div class="page-index__cat-content cat-content">
                <div class="cat-content__list" id="post-list">
                    <exposure-item v-for="item in postExposureList" :data="item" :key="item.id"/>
                </div>
                <!--
                <div class="cat-content__bottom">
                    <a id="view-more" :href="exposureUrl">查看更多&nbsp;&#xe697;</a>
                </div>-->
            </div>
        </div>
        <div class="page-index__cat" id='cat' v-if="postDchsList.length">
            <div class="page-index__cat-title">
                <img class="with-left" :src="huishengImage">
                <div>督查回声</div>
                <img class="with-right" :src="huishengImage">
            </div>
            <div class="page-index__cat-content cat-content">
                <div class="cat-content__title">
                    省政府督查室在省政府“互联网+督查”平台开辟“督查回声”专栏
                </div>
                <div class="cat-content__abstract">
                    <p>
                        省政府“互联网+督查”平台上线运行以来，广大企业和群众大力支持、积极参与，反映了大量政策落实方面的问题线索和意见建议。省政府督查室经过汇总整理，或直接派员核查，或转送有关地市和部门研究办理，经过各级政府部门共同努力，协调解决了一大批企业和群众反映的实际问题，有力推动了党中央、国务院和省委、省政府重大决策部署贯彻落实。</p>
                    <p>
                        为更好回应企业和群众关切，主动接受社会监督，省政府督查室从即日起开辟“督查回声”专栏，不定期发布省政府督查室直接派员核查或各地、各部门反馈的有关问题线索办理结果。欢迎广大企业和群众继续通过省政府“互联网+督查”平台反映问题，提出建议。</p>
                </div>
                <div class="cat-content__list" id="post-list">
                    <post-item v-for="item in postDchsList" :data="item" :key="item.id"/>
                </div>
                <div class="cat-content__bottom">
                    <a id="view-more" :href="categoryUrl">查看更多&nbsp;&#xe697;</a>
                </div>
            </div>
        </div>
        <widget-footer/>
    </div>
</template>

<style scoped lang="less">
    .page-index {
        position: relative;
        background-color: #fffaf7;
        .px2rem(padding-top, 72);

        .page-header-top {
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            .px2rem(height, 72);
            background: #bd1a2d;
            img {
              .px2rem(height, 50);
              .px2rem(margin-left, 20);
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
            }
            .wza {
                background: #ffffff;
                color: #BD1A2D;
                display: inline-block;
                border-radius: 6px;
                .px2rem(margin-right, 20);
                .px2rem(line-height, 50);
                .px2rem(font-size, 30);
                .px2rem(margin-top, 10);
                .px2rem(padding-left, 12);
                .px2rem(padding-right, 12);
            }
        }

        .topic-swiper {
            position: relative;
            overflow: hidden;
            width: 100%;
            .px2rem(padding-top, 60);
            .px2rem(height, 210);
        }

        .swiper-list {
            position: relative;
            overflow: hidden;
            width: 100%;
            .px2rem(height, 150);
        }

        .page-bg {
            width: 100%;
            position: absolute;
            left: 0;
            right: 0;
        }

        .widget-footer {
            background-color: #f0f0f0;
            .px2rem(padding-top, 57);
            .px2rem(padding-bottom, 57);
        }

        button + button {
            .px2rem(margin-top, 30);
        }

        &__content {
            position: relative;
            .px2rem(padding-left, 30);
            .px2rem(padding-right, 30);
            .px2rem(padding-top, 344);
            .px2rem(padding-bottom, 80);

            &-gg {
                background: url("../../assets/img/red_index.png");
                background-size: 100% 100%;
                .px2rem(padding-top, 60);
                .px2rem(padding-bottom, 60);
                .px2rem(padding-left, 40);
                .px2rem(padding-right, 40);
                .px2rem(margin-bottom, 50);

                h1 {
                    text-align: center;
                    .px2rem(font-size, 41);
                    .px2rem(margin-bottom, 40);
                    font-weight: bold;
                    color: @whiteBg;
                }

                p {
                    .px2rem(font-size, 26);
                    line-height: 1.7;
                    text-indent: 2em;
                    color: @whiteBg;
                }


            }
        }
        #exposure .page-index__cat-content{
             .px2rem(padding-top, 10);
             .px2rem(padding-bottom, 10);
        }
        &__cat {
            height: auto;
            background-color: #f0f0f0;
            .px2rem(padding-left, 30);
            .px2rem(padding-right, 30);

            &-title {
                .px2rem(padding-top, 50);
                .px2rem(padding-bottom, 50);
                display: flex;
                align-items: center;
                justify-content: center;

                > div {
                    font-weight: bold;
                    .px2rem(font-size, 42);
                    color: @primaryBg;
                }

                img {
                    .px2rem(width, 36);
                    .px2rem(height, 19);

                    &.with-left {
                        .px2rem(margin-right, 22);
                    }

                    &.with-right {
                        .px2rem(margin-left, 22);
                    }
                }


            }

            &-content {
                position: relative;
                background: @whiteBg;
                margin: 0 auto;
                .px2rem(padding-left, 30);
                .px2rem(padding-right, 30);
                .px2rem(padding-top, 50);
                .px2rem(padding-bottom, 40);
            }

            .cat-content {

                &__title {
                    color: @primaryBg;
                    border-left: 4px solid @primaryBg;
                    .px2rem(padding-left, 16);
                    font-weight: bold;
                    .px2rem(font-size, 36);
                }

                &__abstract {
                    .px2rem(margin-top, 64);
                    color: @otherTextClr;
                    .px2rem(font-size, 28);

                    p {
                        text-align: justify;
                        text-indent: 2em;
                        line-height: 1.9;
                    }
                }

                &__list {
                    .px2rem(margin-top, 40);
                }

                &__bottom {
                    text-align: center;
                    line-height: 0;
                    .px2rem(padding-bottom, 10);

                    a {
                        color: @primaryBg;
                        .px2rem(font-size, 30);
                        font-weight: bold;
                        display: inline-block;
                        font-family: cmsicon;
                    }
                }
            }

        }
    }
</style>
